import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

import { IconSet } from '../../types/icon.types';

@Component({
  selector: 'ds-icon',
  imports: [],
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  public set = input<IconSet>('basic');
  public name = input.required<string>();
  public secondaryName = input<string>();

  protected link = computed(() => `assets/icons/${this.set() ? `${this.set()}/` : ''}icons.svg#${this.name()}`);
  protected secondaryLink = computed(
    () => `assets/icons/${this.set() ? `${this.set()}/` : ''}icons.svg#${this.secondaryName()}`,
  );
}
